import React from 'react';
import { FormikTouched, FormikValues, FormikErrors } from 'formik';
import { Alert, Button, Field, HeaderSection } from '@groupelacentrale/contact-storybook';
import './LoginForm.scss';
import { TermsOfService } from 'components';
import { keypressCallback } from 'utils';

interface Props {
  email: string;
  password: string;
  confirmPassword: string;
  cgu: boolean;
  isSubmitting: boolean;
  errorMessage: string;
  touched: FormikTouched<FormikValues>;
  errors: FormikErrors<FormikValues>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

export const RegisterFormView: React.FC<Props> = ({
  email,
  password,
  confirmPassword,
  cgu,
  isSubmitting,
  errorMessage,
  touched,
  errors,
  handleChange,
  handleSubmit,
  setFieldValue,
}) => {
  const handleKeyPress = keypressCallback((option: 'string') => setFieldValue(option, !cgu), 'data-option');

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <HeaderSection noUnderline>Inscrivez-vous</HeaderSection>
      <Field
        name="email"
        placeholder="Adresse email"
        value={email}
        onChange={handleChange}
        errorMessage={touched.email ? errors.email : undefined}
      />
      <Field
        name="password"
        type="password"
        placeholder="Mot de passe"
        value={password}
        onChange={handleChange}
        errorMessage={touched.password ? errors.password : undefined}
      />
      <Field
        name="confirmPassword"
        type="password"
        placeholder="Confirmer le mot de passe"
        value={confirmPassword}
        onChange={handleChange}
        errorMessage={touched.confirmPassword ? errors.confirmPassword : undefined}
      />
      <div tabIndex={0} data-option="cgu" onKeyPress={handleKeyPress}>
        <TermsOfService checked={cgu} name="cgu" onChange={handleChange} hasError={touched.cgu && !!errors.cgu} />
      </div>
      {touched.cgu && errors.cgu ? <p className="error-message">{errors.cgu}</p> : null}
      <Button label="S'inscrire" type="submit" theme="primary" disabled={isSubmitting} loading={isSubmitting} />
      {errorMessage && <Alert type="error">{errorMessage}</Alert>}
    </form>
  );
};
